document.querySelectorAll('[data-custom-personalization]').forEach(function (root) {
  var mode = root.dataset.mode; // 'text', 'textplus' or 'image'
  // 'textplus' (Customise Your Own Text, Oct 16 2026): same text/font/colour
  // gate as 'text', but the cart line is the flattened design PNG built by
  // custom-personalization-text-plus.js, sent as "Custom Image".
  var textLike = mode === 'text' || mode === 'textplus';
  var submitButton = root.querySelector('[data-custom-personalization-submit]');
  var submitButtonText = root.querySelector('[data-custom-personalization-submit-text]');
  var errorWrapper = root.querySelector('[data-custom-personalization-error]');
  var errorText = root.querySelector('[data-custom-personalization-error-text]');
  var primaryQtyInput = root.querySelector('[data-primary-qty-input]');
  var openMoreSizesButton = root.querySelector('[data-open-more-sizes]');

  if (!submitButton || !errorWrapper || !errorText || !primaryQtyInput) return;

  var promptText = mode === 'image' ? 'Upload design' : 'Add your text';

  // "Need any other size?" -- lets the customer type an exact decimal size
  // instead of only the fixed pills. The real Shopify variant/price picked
  // is always the smallest standard size at or above what they typed, so
  // STP is never undercharged; the exact typed value is sent as a
  // "Custom Size (inches)" line item property, read server-side by
  // Operations OS's parseCustomSizeProperty() in place of the variant's own
  // size. See snippets/custom-personalization-sizes.liquid for the field
  // markup and the min/max derivation, and cart-line-item-options.liquid
  // for how the cart shows this instead of the native Size option.
  //
  // Live (per-keystroke) validation only shows/clears the inline error --
  // it deliberately does NOT touch the size pill. Committing a value (which
  // highlights a pill, updates the price, and shows the confirm note) only
  // happens on blur -- confirmed directly by Akshat live-testing: a pill
  // lighting up mid-keystroke ("5 inches" flashing while typing "4.3")
  // looked like a wrong guess, not a result.
  var customSizeInput = root.querySelector('[data-custom-size-input]');
  var customSizeField = root.querySelector('[data-custom-size-field]');
  var customSizeErrorWrapper = root.querySelector('[data-custom-size-error]');
  var customSizeErrorText = root.querySelector('[data-custom-size-error-text]');
  var customSizeConfirm = root.querySelector('[data-custom-size-confirm]');
  var customSizeActiveValue = null; // committed, 1-decimal string, or null when inactive
  var customSizeHasError = false;

  // Size locked until text/font/color are filled in -- requested directly
  // by Akshat after watching a customer (test session) pick a size before
  // typing anything, which it turns out is backwards for this flow (the
  // size pills exist to override which standard price bracket the already-
  // described design gets charged at; picking one before there's a design
  // to describe doesn't mean anything yet). Only wired up when the sizes
  // snippet rendered the gate markup (gate_on_customization: true, text
  // mode only -- see custom-personalization-sizes.liquid) -- sizeGateMessage
  // being null on the image flow is the signal this whole block is a no-op
  // there, same pattern `clearCustomSizeError`/etc. already use for guards.
  var sizeFieldset = root.querySelector('fieldset[data-size-fieldset]');
  var sizeGateMessage = root.querySelector('[data-size-gate-message]');
  var sizeGateMessageText = root.querySelector('[data-size-gate-message-text]');

  function missingFieldMessage() {
    var textInput = root.querySelector('[data-custom-text-input]');
    var fontSelect = root.querySelector('[data-custom-font-select]');
    var colorSelect = root.querySelector('[data-custom-color-select]');
    if (!textInput || !fontSelect || !colorSelect) return '';
    if (!textInput.value.trim()) return 'Please type your text first.';
    if (!fontSelect.value) return 'Please choose a font first.';
    if (!colorSelect.value) return 'Please choose a color first.';
    return '';
  }

  // Re-locks/unlocks the pills + custom-size field and hides the message
  // once ready -- called on load, on every text/font/color change, and
  // after a successful add-to-cart reset (text/font/color go back to
  // empty, so size should re-lock for whatever the customer makes next).
  function updateSizeGate() {
    if (!sizeGateMessage) return;
    var ready = missingFieldMessage() === '';
    root.querySelectorAll('[data-primary-size-radio][data-size-gated]').forEach(function (radio) {
      radio.disabled = !ready;
    });
    if (customSizeInput && customSizeInput.hasAttribute('data-size-gated')) {
      customSizeInput.readOnly = !ready;
    }
    if (ready) {
      sizeGateMessage.hidden = true;
    }
  }

  function showSizeGateMessage() {
    var msg = missingFieldMessage();
    if (!msg || !sizeGateMessage) return;
    if (sizeGateMessageText) sizeGateMessageText.textContent = msg;
    sizeGateMessage.hidden = false;
  }

  if (sizeFieldset && sizeGateMessage) {
    // Pill radios are visually hidden (clip-rect) -- the customer actually
    // clicks the <label>, which fires a real click regardless of the
    // underlying radio's disabled state, so a delegated listener here
    // reliably catches an attempted click even while locked.
    sizeFieldset.addEventListener('click', function () {
      if (missingFieldMessage()) showSizeGateMessage();
    });
  }

  if (customSizeField && sizeGateMessage) {
    // The custom-size input itself uses `readonly`, not `disabled`, while
    // locked -- a genuinely disabled input suppresses its own click event
    // entirely (nothing to catch), but readonly still fires click/focus
    // normally while blocking typed/pasted input. Listening on the
    // wrapping .field div (not the input) catches the click either way and
    // immediately blurs so no caret sits in a field that can't be typed
    // into.
    customSizeField.addEventListener('click', function () {
      if (missingFieldMessage()) {
        showSizeGateMessage();
        if (customSizeInput) customSizeInput.blur();
      }
    });
  }

  function sizeFromRadio(radio) {
    var label = root.querySelector('label[for="' + radio.id + '"]');
    var text = label ? label.textContent : '';
    var match = text.match(/(\d+(?:\.\d+)?)/);
    return match ? parseFloat(match[1]) : null;
  }

  function clearCustomSizeError() {
    customSizeHasError = false;
    if (!customSizeErrorWrapper) return;
    customSizeErrorWrapper.hidden = true;
    if (customSizeErrorText) customSizeErrorText.textContent = '';
    if (customSizeField) customSizeField.classList.remove('field--with-error');
  }

  function showCustomSizeError(message) {
    customSizeHasError = true;
    if (!customSizeErrorWrapper || !customSizeErrorText) return;
    customSizeErrorText.textContent = message;
    customSizeErrorWrapper.hidden = false;
    if (customSizeField) customSizeField.classList.add('field--with-error');
  }

  function clearCustomSizeConfirm() {
    if (!customSizeConfirm) return;
    customSizeConfirm.hidden = true;
    customSizeConfirm.textContent = '';
  }

  // Format/range check only -- never touches a radio. Returns the rounded
  // value on success (and leaves any error message in place on failure).
  function validateCustomSize(raw) {
    clearCustomSizeError();
    if (!/^\d+(\.\d)?$/.test(raw)) {
      showCustomSizeError('Enter a size in inches, up to 1 decimal place (e.g. 5.5).');
      return null;
    }
    var value = Math.round(parseFloat(raw) * 10) / 10;
    var min = parseFloat(customSizeInput.dataset.minSize);
    var max = parseFloat(customSizeInput.dataset.maxSize);
    if (value < min || value > max) {
      showCustomSizeError('Size must be between ' + min + '" and ' + max + '".');
      return null;
    }
    return value;
  }

  function onCustomSizeInput() {
    var raw = customSizeInput.value.trim();
    if (!raw) {
      clearCustomSizeError();
    } else {
      validateCustomSize(raw);
    }
    // Deliberately no pill change, no price change, no confirm note here --
    // see the block comment above. refreshSubmitGate still runs so an error
    // disables Add to Cart immediately rather than waiting for blur.
    refreshSubmitGate();
  }

  // Commits the typed value: highlights the matching pill, updates price,
  // shows the confirm note. Runs on blur (including the blur a click on
  // Add to Cart naturally causes, so a value typed and immediately
  // submitted still commits correctly) -- never while still typing.
  // Removes the marker CSS uses to suppress the "checked" pill highlight
  // for a custom-size-driven selection (see custom-personalization.css) --
  // called whenever the custom size stops being the thing in charge of the
  // current selection, so a size the customer clicks directly afterward
  // highlights normally again.
  function clearCustomSizeDrivenAttr() {
    var marked = root.querySelector('[data-primary-size-radio][data-custom-size-driven]');
    if (marked) marked.removeAttribute('data-custom-size-driven');
  }

  function onCustomSizeBlur() {
    var raw = customSizeInput.value.trim();
    clearCustomSizeConfirm();
    customSizeActiveValue = null;

    if (!raw) {
      clearCustomSizeError();
      refreshSubmitGate();
      return;
    }

    var value = validateCustomSize(raw);
    if (value === null) {
      refreshSubmitGate();
      return;
    }

    // Smallest standard size at or above the requested size -- this is the
    // variant that gets charged, so STP is never undercharged.
    var best = null;
    var bestSize = null;
    root.querySelectorAll('[data-primary-size-radio]').forEach(function (radio) {
      var size = sizeFromRadio(radio);
      if (size === null || size + 0.001 < value) return;
      if (bestSize === null || size < bestSize) {
        bestSize = size;
        best = radio;
      }
    });

    if (!best) {
      // Shouldn't happen (value is already bounds-checked against the
      // product's own min/max), but fail safe rather than silently commit.
      showCustomSizeError(
        'Size must be between ' + customSizeInput.dataset.minSize + '" and ' + customSizeInput.dataset.maxSize + '".'
      );
      refreshSubmitGate();
      return;
    }

    customSizeActiveValue = String(value);
    clearCustomSizeDrivenAttr();
    root.dataset.syncingCustomSize = 'true';
    best.checked = true;
    best.setAttribute('data-custom-size-driven', '');
    best.dispatchEvent(new Event('change', { bubbles: true }));
    delete root.dataset.syncingCustomSize;

    if (customSizeConfirm) {
      customSizeConfirm.hidden = false;
      customSizeConfirm.textContent = "We'll size your design to exactly " + value + '".';
    }
    refreshSubmitGate();
  }

  if (customSizeInput) {
    customSizeInput.addEventListener('input', onCustomSizeInput);
    customSizeInput.addEventListener('blur', onCustomSizeBlur);
    customSizeInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') customSizeInput.blur();
    });
  }

  // A real (not synthetic) click on a standard pill after a custom size was
  // active means the customer changed their mind -- drop the custom value
  // rather than silently keep charging/sizing against a stale request.
  root.querySelectorAll('[data-primary-size-radio]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      if (root.dataset.syncingCustomSize === 'true') return;
      if (customSizeInput) customSizeInput.value = '';
      customSizeActiveValue = null;
      clearCustomSizeError();
      clearCustomSizeConfirm();
      clearCustomSizeDrivenAttr();
    });
  });

  // Bold, not disabled-looking, is the signal that a size will actually be
  // added -- applies to any row the customer has set a quantity on directly.
  function syncRowEmphasis(input) {
    var row = input.closest('.custom-personalization__size-row');
    if (!row) return;
    var quantity = parseInt(input.value, 10) || 0;
    row.toggleAttribute('data-has-qty', quantity > 0);
  }

  // Document-scoped, not root-scoped: <modal-dialog> (the "other sizes" list)
  // moves itself to document.body as soon as the browser parses it, so its
  // rows are no longer descendants of `root` by the time this runs.
  function qtyStepperButtons() {
    document.querySelectorAll('[data-qty-decrease]').forEach(function (btn) {
      if (btn.dataset.boundToPersonalization) return;
      btn.dataset.boundToPersonalization = 'true';
      btn.addEventListener('click', function () {
        var wrapper = btn.closest('.custom-personalization__qty');
        var input = wrapper.querySelector('input');
        var min = parseInt(input.min, 10) || 0;
        input.value = Math.max(min, (parseInt(input.value, 10) || 0) - 1);
        syncRowEmphasis(input);
      });
    });
    document.querySelectorAll('[data-qty-increase]').forEach(function (btn) {
      if (btn.dataset.boundToPersonalization) return;
      btn.dataset.boundToPersonalization = 'true';
      btn.addEventListener('click', function () {
        var wrapper = btn.closest('.custom-personalization__qty');
        var input = wrapper.querySelector('input');
        input.value = (parseInt(input.value, 10) || 0) + 1;
        syncRowEmphasis(input);
      });
    });
    document.querySelectorAll('[data-qty-input]').forEach(function (input) {
      if (input.dataset.emphasisBound) return;
      input.dataset.emphasisBound = 'true';
      input.addEventListener('input', function () {
        syncRowEmphasis(input);
      });
    });
  }
  qtyStepperButtons();

  // Same reasoning: the modal's own "Add to cart" button lives inside
  // <modal-dialog>, which has already moved to document.body by the time
  // this runs. It just re-triggers the main submit button so there's a
  // single source of truth for the add-to-cart logic.
  var modalSubmitButton = document.querySelector('[data-modal-submit]');
  if (modalSubmitButton && !modalSubmitButton.dataset.boundToPersonalization) {
    modalSubmitButton.dataset.boundToPersonalization = 'true';
    modalSubmitButton.addEventListener('click', function () {
      submitButton.click();
    });
  }

  function showError(message) {
    errorText.textContent = message;
    errorWrapper.hidden = false;
  }

  function clearError() {
    errorWrapper.hidden = true;
    errorText.textContent = '';
  }

  function setLoading(loading) {
    submitButton.toggleAttribute('aria-disabled', loading);
    submitButton.classList.toggle('loading', loading);
    var spinner = submitButton.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !loading);

    // Whichever button the customer actually sees (main page or the "other
    // sizes" popup) needs its own visible loading state -- clicking the
    // modal button only re-triggers the main one under the hood, and its
    // spinner is out of view behind the modal.
    if (modalSubmitButton) {
      modalSubmitButton.disabled = loading;
      modalSubmitButton.classList.toggle('loading', loading);
      var modalSpinner = modalSubmitButton.querySelector('.loading__spinner');
      if (modalSpinner) modalSpinner.classList.toggle('hidden', !loading);
    }
  }

  function isCustomizationComplete() {
    if (textLike) {
      var textInput = root.querySelector('[data-custom-text-input]');
      var fontSelect = root.querySelector('[data-custom-font-select]');
      var colorSelect = root.querySelector('[data-custom-color-select]');
      return !!(textInput.value.trim() && fontSelect.value && colorSelect.value);
    }
    var fileInput = root.querySelector('[data-custom-image-input]');
    return !!((fileInput.files && fileInput.files[0]) || root.dataset.prefillImageUrl);
  }

  // The native Dawn price block has no idea a custom size picker replaced
  // the variant picker -- left alone it always shows the first (cheapest)
  // variant's price regardless of what's actually selected. Hide it until a
  // size is chosen, then show that size's real price, reusing the price
  // text already rendered in the size row rather than reformatting money
  // ourselves.
  function syncNativePrice() {
    // The theme's own native price block has no idea a custom size picker
    // replaced the variant picker and always shows the first (cheapest)
    // variant regardless of selection -- permanently hidden, replaced by
    // our own price line positioned right where it belongs: below sizes,
    // above quantity.
    var nativePriceWrapper = document.querySelector('[id^="price-"]');
    if (nativePriceWrapper) nativePriceWrapper.style.display = 'none';

    var ownPrice = root.querySelector('[data-custom-personalization-price]');
    if (!ownPrice) return;

    var primaryRadio = root.querySelector('[data-primary-size-radio]:checked');
    if (!primaryRadio) {
      ownPrice.hidden = true;
      return;
    }

    var row = document.querySelector('[data-qty-input][data-variant-id="' + primaryRadio.value + '"]');
    var priceRow = row ? row.closest('.custom-personalization__size-row') : null;
    var priceText = priceRow ? priceRow.querySelector('.custom-personalization__size-price').textContent : '';

    ownPrice.textContent = priceText;
    ownPrice.hidden = !priceText;
  }

  function refreshSubmitGate() {
    var complete = isCustomizationComplete();
    var sizeSelected = !!root.querySelector('[data-primary-size-radio]:checked');

    if (customSizeHasError) {
      submitButton.disabled = true;
      submitButtonText.textContent = 'Fix custom size';
    } else if (!complete) {
      submitButton.disabled = true;
      submitButtonText.textContent = promptText;
    } else if (!sizeSelected) {
      submitButton.disabled = true;
      submitButtonText.textContent = 'Select size';
    } else {
      submitButton.disabled = false;
      submitButtonText.textContent = 'Add to cart';
    }

    if (openMoreSizesButton) openMoreSizesButton.disabled = !(complete && sizeSelected && !customSizeHasError);
    syncNativePrice();
  }

  refreshSubmitGate();
  updateSizeGate();

  root.querySelectorAll('[data-primary-size-radio]').forEach(function (radio) {
    radio.addEventListener('change', refreshSubmitGate);
  });

  if (textLike) {
    ['[data-custom-text-input]', '[data-custom-font-select]', '[data-custom-color-select]'].forEach(function (sel) {
      var el = root.querySelector(sel);
      if (el) el.addEventListener('input', refreshSubmitGate);
      if (el) el.addEventListener('change', refreshSubmitGate);
      if (el) el.addEventListener('input', updateSizeGate);
      if (el) el.addEventListener('change', updateSizeGate);
    });
  } else {
    var fileInput = root.querySelector('[data-custom-image-input]');
    if (fileInput) fileInput.addEventListener('change', refreshSubmitGate);
  }

  // The "add other sizes" modal lists every size, including whichever one is
  // currently the primary selection above -- that one is shown disabled and
  // synced to the primary quantity rather than being a second independent
  // input for the same variant (would otherwise double-count on submit).
  function syncModalWithPrimary() {
    var primaryRadio = root.querySelector('[data-primary-size-radio]:checked');
    var primaryVariantId = primaryRadio ? primaryRadio.value : null;

    document.querySelectorAll('[data-qty-input]').forEach(function (input) {
      var row = input.closest('.custom-personalization__size-row');
      var isSoldOut = input.hasAttribute('data-sold-out');
      var isPrimary = primaryVariantId && input.dataset.variantId === primaryVariantId;
      var wasPrimary = row && row.hasAttribute('data-linked-to-primary');

      if (isPrimary) {
        input.value = primaryQtyInput.value;
        input.disabled = true;
        if (row) row.setAttribute('data-linked-to-primary', '');
      } else {
        // If this row was only showing a quantity because it used to be the
        // primary selection (auto-mirrored, not something the customer
        // typed here themselves), clear it back to 0 now that it's no
        // longer primary -- otherwise it silently lingers as an
        // independent "add this too" row and gets added a second time
        // alongside whichever size is now actually selected.
        if (wasPrimary) {
          input.value = 0;
          if (row) row.removeAttribute('data-has-qty');
        }
        if (!isSoldOut) input.disabled = false;
        if (row) row.removeAttribute('data-linked-to-primary');
      }
    });
  }

  if (openMoreSizesButton) {
    openMoreSizesButton.addEventListener('click', syncModalWithPrimary);
  }
  primaryQtyInput.addEventListener('input', syncModalWithPrimary);
  root.querySelectorAll('[data-primary-size-radio]').forEach(function (radio) {
    radio.addEventListener('change', syncModalWithPrimary);
  });

  function collectSelections() {
    var byVariant = {};

    var primaryRadio = root.querySelector('[data-primary-size-radio]:checked');
    var primaryVariantId = primaryRadio ? primaryRadio.value : null;

    if (primaryRadio) {
      var primaryQty = parseInt(primaryQtyInput.value, 10) || 0;
      if (primaryQty > 0) byVariant[primaryVariantId] = primaryQty;
    }

    document.querySelectorAll('[data-qty-input]').forEach(function (input) {
      if (input.dataset.variantId === primaryVariantId) return; // governed by the primary stepper instead
      var quantity = parseInt(input.value, 10) || 0;
      if (quantity > 0) {
        var variantId = input.dataset.variantId;
        byVariant[variantId] = (byVariant[variantId] || 0) + quantity;
      }
    });

    return Object.keys(byVariant).map(function (variantId) {
      return { variantId: variantId, quantity: byVariant[variantId] };
    });
  }

  function collectTextProperties() {
    var textInput = root.querySelector('[data-custom-text-input]');
    var fontSelect = root.querySelector('[data-custom-font-select]');
    var colorSelect = root.querySelector('[data-custom-color-select]');

    if (!textInput.value.trim()) return { error: 'Please enter your text.' };
    if (!fontSelect.value) return { error: 'Please choose a font.' };
    if (!colorSelect.value) return { error: 'Please choose a color.' };
    if (customSizeHasError) return { error: 'Please fix the custom size, or clear it to use a standard size.' };

    var properties = {
      'Custom Text': textInput.value.trim(),
      Font: fontSelect.value,
      Color: colorSelect.value,
    };
    if (customSizeActiveValue) properties['Custom Size (inches)'] = customSizeActiveValue;

    return {
      properties: properties,
    };
  }

  function collectImageSource() {
    var fileInput = root.querySelector('[data-custom-image-input]');
    if (fileInput.files && fileInput.files[0]) return { file: fileInput.files[0] };
    if (root.dataset.prefillImageUrl) return { existingUrl: root.dataset.prefillImageUrl };
    return { error: 'Please upload an image.' };
  }

  function addItemJson(variantId, quantity, properties, sectionsParam) {
    var body = { id: variantId, quantity: quantity, properties: properties };
    if (sectionsParam) {
      body.sections = sectionsParam;
      body.sections_url = window.location.pathname;
    }
    return fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (res) {
      return res.json();
    });
  }

  // All remaining sizes in ONE request instead of one round trip per size --
  // meaningfully more reliable on a slow connection (confirmed: /cart/add.js
  // accepts a bulk `items` array, not just a single item).
  function addItemsBulk(items, sectionsParam) {
    var body = { items: items };
    if (sectionsParam) {
      body.sections = sectionsParam;
      body.sections_url = window.location.pathname;
    }
    return fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (res) {
      return res.json();
    });
  }

  function addFirstItemWithFile(variantId, quantity, file, sectionsParam, extraProperties) {
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);
    formData.append('properties[Custom Image]', file);
    if (extraProperties) {
      Object.keys(extraProperties).forEach(function (k) {
        formData.append('properties[' + k + ']', extraProperties[k]);
      });
    }
    if (sectionsParam) {
      formData.append('sections', sectionsParam);
      formData.append('sections_url', window.location.pathname);
    }
    return fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    }).then(function (res) {
      return res.json();
    });
  }

  function renderCartSections(response) {
    // Render directly from the /cart/add.js response itself -- confirmed
    // correct in every case, including a brand new (previously empty) cart,
    // since it reflects the cart state from the exact same request that
    // performed the mutation. A separate follow-up GET request was tried
    // here as a defensive measure against a suspected third-party app race,
    // but a plain GET immediately after the cart's very first item is added
    // can be served stale relative to that mutation on Shopify's real edge
    // infrastructure (not reproducible against the local dev proxy, which
    // is why it passed every local test) -- removed since it was the actual
    // cause of empty-looking item rows specifically on a cart's first add.
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (cart && typeof cart.renderContents === 'function' && response.sections) {
      cart.renderContents(response);
    }

    // renderContents() only replaces the INNER content of #CartDrawer, never
    // the outer <cart-drawer>/<cart-drawer-items> elements themselves -- so
    // the "is-empty" class those carry from initial page load (when the
    // cart genuinely was empty) never gets cleared by our custom flow the
    // way Dawn's own native quantity-change code does. Left stuck, CSS rules
    // like "cart-drawer.is-empty .drawer__header { display: none }" keep
    // hiding real content even though correct item HTML just got injected
    // underneath it -- this was the actual root cause of the empty-looking
    // drawer specifically on a cart's first add (never an issue once the
    // cart already had an item, since is-empty was never present then).
    var cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl) cartDrawerEl.classList.remove('is-empty');
    var cartDrawerItemsEl = document.querySelector('cart-drawer-items');
    if (cartDrawerItemsEl) cartDrawerItemsEl.classList.remove('is-empty');
  }

  function resetForm() {
    if (typeof root.customPersonalizationReset === 'function') root.customPersonalizationReset();
    delete root.dataset.prefillImageUrl;

    root.querySelectorAll('[data-primary-size-radio]').forEach(function (r) {
      r.checked = false;
    });
    primaryQtyInput.value = 1;

    document.querySelectorAll('[data-qty-input]').forEach(function (input) {
      input.value = 0;
      if (!input.hasAttribute('data-sold-out')) input.disabled = false;
      var row = input.closest('.custom-personalization__size-row');
      if (row) {
        row.removeAttribute('data-linked-to-primary');
        row.removeAttribute('data-has-qty');
      }
    });

    var modalOpener = root.querySelector('modal-opener[data-modal]');
    var modal = modalOpener ? document.querySelector(modalOpener.getAttribute('data-modal')) : null;
    if (modal && typeof modal.hide === 'function') modal.hide();

    if (customSizeInput) customSizeInput.value = '';
    customSizeActiveValue = null;
    clearCustomSizeError();
    clearCustomSizeConfirm();
    clearCustomSizeDrivenAttr();
    if (sizeGateMessage) sizeGateMessage.hidden = true;

    clearError();
    refreshSubmitGate();
    updateSizeGate();
  }

  submitButton.addEventListener('click', function () {
    clearError();

    var selections = collectSelections();
    if (selections.length === 0) {
      showError('Please choose a quantity for at least one size.');
      return;
    }

    var custom = textLike ? collectTextProperties() : collectImageSource();
    if (custom.error) {
      showError(custom.error);
      return;
    }

    setLoading(true);

    var sectionsParam = 'cart-drawer,cart-icon-bubble';
    var first = selections[0];
    var rest = selections.slice(1);
    var isLastCallForFirst = rest.length === 0;

    var firstProperties = mode === 'text' ? custom.properties : custom.existingUrl ? { 'Custom Image': custom.existingUrl } : null;

    // textplus: build the print PNG first; its label properties (plus any
    // "Custom Size (inches)") ride along on every size's line.
    var designProperties = null;
    var firstRequest;
    if (mode === 'textplus') {
      firstRequest = root.customPersonalizationBuildFile().then(function (built) {
        designProperties = Object.assign({}, built.properties);
        if (custom.properties['Custom Size (inches)']) {
          designProperties['Custom Size (inches)'] = custom.properties['Custom Size (inches)'];
        }
        return addFirstItemWithFile(
          first.variantId,
          first.quantity,
          built.file,
          isLastCallForFirst ? sectionsParam : null,
          designProperties
        );
      });
    } else {
      firstRequest = firstProperties
        ? addItemJson(first.variantId, first.quantity, firstProperties, isLastCallForFirst ? sectionsParam : null)
        : addFirstItemWithFile(first.variantId, first.quantity, custom.file, isLastCallForFirst ? sectionsParam : null);
    }

    firstRequest
      .then(function (firstResponse) {
        if (firstResponse.status) {
          throw new Error(firstResponse.description || firstResponse.message || 'Could not add to cart.');
        }

        if (rest.length === 0) return firstResponse;

        var properties =
          mode === 'text'
            ? custom.properties
            : mode === 'textplus'
            ? Object.assign({ 'Custom Image': firstResponse.properties['Custom Image'] }, designProperties)
            : { 'Custom Image': firstResponse.properties['Custom Image'] };

        var bulkItems = rest.map(function (selection) {
          return { id: selection.variantId, quantity: selection.quantity, properties: properties };
        });

        return addItemsBulk(bulkItems, sectionsParam).then(function (response) {
          if (response.status || response.description) {
            throw new Error(response.description || response.message || 'Could not add all sizes to cart.');
          }
          return response;
        });
      })
      .then(function (finalResponse) {
        renderCartSections(finalResponse);
        // Mirrors Dawn's own product-form.js: publishes the same pub/sub
        // event any properly-integrated cart app (upsell/progress-bar
        // widgets etc.) listens for, since this custom multi-add flow
        // bypasses that native form entirely and would otherwise never
        // notify them a cart change happened.
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'custom-personalization',
            productVariantId: first.variantId,
            cartData: finalResponse,
          });
        }
        resetForm();
      })
      .catch(function (err) {
        showError(err.message || 'Something went wrong adding these to your cart. Please try again.');
      })
      .finally(function () {
        setLoading(false);
      });
  });

  // Edit-from-cart: the cart's "Edit" link sends the customer back here with
  // the previous line's details in the URL so they don't have to redo their
  // design from scratch.
  var params = new URLSearchParams(window.location.search);
  if (params.get('edit_variant')) {
    var editVariantId = params.get('edit_variant');
    var radio = root.querySelector('[data-primary-size-radio][value="' + editVariantId + '"]');
    if (radio) {
      radio.checked = true;
      refreshSubmitGate();
    }
    if (params.get('edit_qty')) primaryQtyInput.value = params.get('edit_qty');

    if (mode === 'text' && typeof root.customPersonalizationPrefill === 'function') {
      root.customPersonalizationPrefill({
        text: params.get('edit_text') || '',
        font: params.get('edit_font') || '',
        color: params.get('edit_color') || '',
      });
    } else if (mode === 'textplus' && typeof root.customPersonalizationPrefill === 'function') {
      if (params.get('edit_image')) root.customPersonalizationPrefill({ imageUrl: params.get('edit_image') });
      else
        root.customPersonalizationPrefill({
          text: params.get('edit_text') || '',
          font: params.get('edit_font') || '',
          color: params.get('edit_color') || '',
        });
    } else if (mode === 'image' && params.get('edit_image') && typeof root.customPersonalizationPrefill === 'function') {
      root.customPersonalizationPrefill({ imageUrl: params.get('edit_image') });
    }
    refreshSubmitGate();
  }
});
